import tzNames from 'src/components/lib/tz/tznames.json';
import {customTimezones, excludedTimezones} from './constants';


export const isValidTimezone = (timezone: string): boolean => {
  const timezoneKeys = [
    ...Object.keys(tzNames),
    ...Object.keys(customTimezones),
  ];
  const filteredTimezoneKeys = timezoneKeys.filter(
    (key) => !excludedTimezones.includes(key),
  );

  return filteredTimezoneKeys.includes(timezone);
};
